import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Http from "../../Http";
import { Insurance_API } from "../../Helper";
import {
  AiOutlineSafety,
  AiOutlinePlusCircle,
  AiOutlineFileProtect,
  AiOutlineSmile,
} from "react-icons/ai";
import { FaMotorcycle } from "react-icons/fa"; // Import bike/motorcycle icon

function Icon({ id, open }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={2}
      stroke="currentColor"
      className={`${
        id === open ? "rotate-180" : ""
      } h-5 w-5 transition-transform`}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M19.5 8.25l-7.5 7.5-7.5-7.5"
      />
    </svg>
  );
}

const BikeInsuranceNew = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [insuranceData, setInsuranceData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const faqs = [
    {
      question: "What is two-wheeler insurance?",
      answer:
        "Two-wheeler insurance is a type of insurance policy that provides financial coverage for motorbikes and scooters. It covers costs related to accidents, theft, damage, and liability for injuries or property damage caused by your two-wheeler. This insurance is designed to protect you from financial losses associated with owning and operating a two-wheeler.",
    },
    {
      question:
        "What factors should I consider when choosing a two-wheeler insurance policy?",
      answer:
        "When selecting two-wheeler insurance, consider factors such as the type of coverage (third-party liability vs. comprehensive), premium cost, deductible amount, policy limits, and additional features like roadside assistance. It is also important to check if the insurance covers accessories, modifications, or protective gear and whether there are discounts available for things like safe riding or multi-year policies.",
    },
    {
      question: "Why is two-wheeler insurance important?",
      answer:
        "Two-wheeler insurance is important because it provides financial protection in case of accidents, theft, or damage to your motorbike or scooter. It also offers liability coverage, which is essential if you cause injury to someone or damage to their property while riding. Without two-wheeler insurance, you could face significant financial or legal consequences in the event of an incident.",
    },
    {
      question: "Can I buy two-wheeler insurance through TheFinMaster.com?",
      answer:
        " TheFinMaster.com is not a two-wheeler insurance provider. We offer educational resources, policy comparison tools, and impartial information to help you understand different types of two-wheeler insurance and find the right policy for your needs. Once you have identified the best coverage, you will be directed to the insurance providers website to complete a secure application process.",
    },
    {
      question: "What is the difference between third-party and comprehensive two-wheeler insurance?",
      answer:
        "Third-party insurance covers liabilities towards a third party in case of injury or damage and is mandatory by law. Comprehensive insurance includes both third-party coverage and protection against theft, accidents, natural calamities, and damage to your own bike.",
    },
    {
      question: "How is the premium for two-wheeler insurance calculated?",
      answer:
        " Premiums are based on factors like bike model, age, engine capacity, registration location, previous claim history, and the type of policy chosen. Comprehensive plans and add-ons lead to higher premiums but offer better coverage.",
    },
    {
      question: "What is a No Claim Bonus (NCB) in two-wheeler insurance?",
      answer:
        "  NCB is a reward for not making any claims during the policy term and is offered as a discount on the renewal premium. It ranges from 20% to 50% over consecutive claim-free years and can be transferred when switching insurers.",
    },
    {
      question: "Can I transfer my bike insurance to a new owner?",
      answer:
        "  Yes, the insurance policy can be transferred when you sell your bike. You need to inform your insurer, submit transfer documents, and request a name update. The NCB, however, stays with the original owner and is non-transferable.",
    },
    {
      question: "What is IDV in two-wheeler insurance?",
      answer:
        "  IDV (Insured Declared Value) is the estimated market value of your bike and represents the maximum sum you can claim in case of total loss or theft. IDV decreases each year due to depreciation, and it influences your premium amount.",
    },
    {
      question: "Is long-term two-wheeler insurance beneficial?",
      answer:
        "  Yes, long-term policies (2 to 5 years) protect you from annual premium hikes and reduce the hassle of yearly renewals. They also ensure uninterrupted coverage and eligibility for continued NCB accumulation.",
    },
    {
      question: "Are there any add-ons for two-wheeler insurance?",
      answer:
        "  Yes, add-ons like zero depreciation, roadside assistance, engine protection, and personal accident cover for pillion riders enhance the policy’s benefits. These come at an extra cost but offer better financial protection in case of emergencies.",
    },
    {
      question: "Can I renew my two-wheeler insurance after it expires?",
      answer:
        " Yes, but you should do it as soon as possible. Most insurers offer a grace period after expiry, but once that lapses, you may lose benefits like NCB and will require vehicle inspection. Driving without valid insurance is also a legal offense.",
    },
    {
      question: "How do I file a claim for two-wheeler insurance?",
      answer:
        " To file a claim, contact your insurer immediately and share the incident details. Submit the necessary documents like FIR (if needed), policy copy, driving license, and vehicle RC. The insurer will inspect and settle the claim accordingly.",
    },
    {
      question: "Is two-wheeler insurance mandatory in India?",
      answer:
        "  Yes, as per the Motor Vehicles Act, having at least a third-party insurance policy is mandatory for all two-wheelers in India. Failing to comply can lead to legal penalties and financial risks in case of accidents or damages.",
    },
    
  ];
  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  const featuresNew = [
    {
      icon: <AiOutlineSafety className="mx-auto text-blue-500 h-10 w-10" />,
      title: " Shield Your Finances from Major Losses",
      description:
        "Accidents, theft, fire, and natural disasters can lead to heavy repair or replacement costs. A bike insurance policy saves you from paying out of pocket and also helps you avoid hefty traffic fines.",
    },
    {
      icon: <FaMotorcycle className="mx-auto text-blue-500 h-10 w-10" />,
      title: "Hassle-Free Coverage for Third-Party Damages",
      description:
        "If your bike causes damage to another vehicle, property, or person, third-party insurance covers the costs, protecting you from financial and legal troubles.",
    },
    {
      icon: <AiOutlinePlusCircle className="mx-auto text-blue-500 h-10 w-10" />,
      title: "Upgrade Protection with Add-Ons",
      description:
        "A comprehensive bike insurance policy allows you to enhance coverage with add-ons like zero depreciation, roadside assistance, and engine protection for a smoother riding experience.",
    },
    {
      icon: (
        <AiOutlineFileProtect className="mx-auto text-blue-500 h-10 w-10" />
      ),
      title: " Stay Legally Compliant",
      description:
        "According to the Motor Vehicles Act, riding without at least third-party insurance can result in fines of ₹2,000 for the first offense and ₹4,000 for repeat violations.",
    },
    {
      icon: <AiOutlineSmile className="mx-auto text-blue-500 h-10 w-10" />,
      title: "Ride with Peace of Mind",
      description:
        "Whether you’re commuting daily or enjoying long rides, bike insurance ensures you have financial and legal support, letting you ride confidently without worries.",
    },
  ];

  const cardsNew = [
    {
      title: "Accidents & Collisions",
      description:
        "Covers repair costs for damages caused by road accidents or sudden collisions.",
      image: "accident.png",
    },
    {
      title: "Theft Protection",
      description: "Compensates for financial losses if your bike is stolen.",
      image: "theft.png",
    },
    {
      title: " Fire Damage",
      description:
        "Provides coverage for accidental fires that may damage or destroy your two-wheeler.",
      image: "fire.png",
    },
    {
      title: "Natural Disasters",
      description:
        "Covers damages caused by floods, earthquakes, storms, and other calamities.",
      image: "disaster.png",
    },
    {
      title: "Personal Accident Cover",
      description:
        "Offers financial support in case of injury, disability, or death of the policyholder.",
      image: "personal-accident.png",
    },
    {
      title: "Third-Party Liability",
      description:
        "Protects you from legal and financial responsibilities if your bike causes damage to another person’s vehicle, property, or results in injury.",
      image: "third-party.png",
    },
  ];

  const points = [
    {
      title: " ✔ Coverage Type: ",
      description: `Decide between a third-party liability plan (mandatory by law) or a comprehensive policy that also covers damages to your own bike.`,
    },
    {
      title: "➕ Add-Ons & Riders:",
      description: `Strengthen your policy with add-ons like zero depreciation, engine protection, roadside assistance, and return to invoice cover.`,
    },
    {
      title: "🚑 Personal Accident Cover:",
      description: ` Ensure your policy includes financial protection for the rider and pillion in case of injury, disability, or death.`,
    },
    {
      title: "📊 Claim Settlement Ratio: ",
      description: ` Choose an insurer with a high claim settlement ratio to ensure a smooth and reliable claim process.`,
    },
    {
      title: "🔧 Cashless Network Garages:",
      description: ` Look for insurers that provide cashless repair services at a wide network of authorized garages.`,
    },
    {
      title: "💰 Premium & Deductibles: ",
      description: `Compare premium rates and deductible amounts to strike the right balance between affordability and adequate protection.`,
    },
    {
      title: "📜 Exclusions & Limitations: ",
      description: `Read the fine print carefully to understand what is not covered under your policy to avoid claim-related surprises.`,
    },
    {
      title: "🎖 No Claim Bonus (NCB):",
      description: ` Check if the insurer provides NCB benefits for claim-free years and whether it’s transferable if you switch insurers.`,
    },
    {
      title: "📝 Read Terms & Conditions Carefully: ",
      description: `Before purchasing, go through all policy details, including exclusions, renewal terms, and claim procedures.`,
    },
    {
      title: "⚙ Zero Depreciation Cover: ",
      description: `Since bike value depreciates over time, opting for a zero depreciation add-on ensures you receive the full claim amount without deductions.`,
    },
  ];
  const points2 = [
    {
      title: " ✔ Make & Model: ",
      description: `The brand, engine capacity (cc), and variant of your bike significantly impact the insurance premium. High-end sports bikes and superbikes attract higher premiums compared to commuter bikes.`,
    },
    {
      title: "📆 Car Age & Depreciation:",
      description: `Older bikes have a lower Insured Declared Value (IDV) due to depreciation, which reduces the premium, whereas newer bikes have a higher IDV, resulting in higher insurance costs.`,
    },
    {
      title: "⚙ Engine Capacity (CC):",
      description: `The insurance premium is directly linked to the cubic capacity of the bike’s engine. Higher CC bikes (above 350cc) generally have steeper premiums due to their speed and risk factors.`,
    },
    {
      title: "📍 Location Factor:",
      description: `Bikes registered in metro cities or areas with high traffic and theft risks tend to have higher insurance premiums compared to those in smaller towns or rural regions.`,
    },
    {
      title: "➕ Add-Ons & Riders:",
      description: `Opting for additional covers like zero depreciation, roadside assistance, and engine protection increases the premium but provides enhanced financial security.`,
    },
    {
      title: "🎖 No Claim Bonus (NCB): ",
      description: ` If you do not file any claims during your policy tenure, you can avail of discounts on your premium at renewal, with the discount percentage increasing every claim-free year.`,
    },
    {
      title: "💻 Online Purchase Advantage: ",
      description: `Buying bike insurance online enables easy comparison of different plans, customization of coverage, and exclusive discounts, making it a cost-effective and hassle-free option.`,
    },
  ];

  const data = [
    ["Damages/Losses to own car due to an accident", false, true, true],
    ["Damages/Losses to own car in case of fire", false, true, true],
    ["Damages/Losses to own car in case of a natural calamity", false, true, true],
    ["Damages to Third-Party Vehicle", true, true, false],
    ["Damages to Third-Party Property", true, true, false],
    ["Personal Accident Cover", true, true, false],
    ["Injuries/Death of a Third-Party Person", true, true, false],
    ["Theft of your car", false, true, true],
    ["Customize your IDV", false, true, true],
    ["Extra protection with customized add-ons", false, true, true],
  ];

  useEffect(() => {
    fetchInsuranceData();
  }, []);
  const fetchInsuranceData = async () => {
    try {
      const response = await Http.get(Insurance_API);

      // The response structure might have nested data
      // Check if response has an insurance property (like in the original fetch response)
      const data = response.insurance || response;

      // Filter the insurance data to show only Car category
      const carInsuranceData = Array.isArray(data)
        ? data.filter((insurance) => insurance.category_name === "Bike")
        : [];

      setInsuranceData(carInsuranceData);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch insurance data");
      setLoading(false);
      console.error("Error fetching data:", error);
    }
  };

  // const fetchInsuranceData = async () => {
  //     try {
  //         const response = await fetch('https://test.thefinmaster.com/console/react-app-directory/insurance-api.php');
  //         if (!response.ok) {
  //             throw new Error('Network response was not ok');
  //         }
  //         const data = await response.json();
  //         setInsuranceData(data.insurance || []);
  //         setLoading(false);
  //     } catch (error) {
  //         setError('Failed to fetch insurance data');
  //         setLoading(false);
  //         console.error('Error fetching data:', error);
  //     }
  // };
  return (
    <>
      <Helmet>
        <title>
          Bike Insurance Online: Buy/Renew Two Wheeler Insurance at ₹547*
        </title>
        <meta
          name="description"
          content="Bike Insurance: Buy Two Wheeler Insurance in just 60 Seconds starting at ₹1.3* per day. Renew bike insurance online and Save upto 60%*."
        />
        <meta
          name="keywords"
          content="bike insurance companies, 1 year bike ins, motorcycle insurance companiesurance price, hdfc 2 wheeler insurance, icici lombard two wheeler insurance"
        />
        <link rel="canonical" href="https://thefinmaster.com/bike_insurance" />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>
          <li className="flex items-center">
            <span className="text-gray-500 ">Bike Insurance</span>
          </li>
          {/* <li className="flex items-center">
              <Link to="/credit-card" className="text-blue-600 hover:text-blue-800">Credit Card</Link>
              <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
              </svg>
            </li> */}
          {/* <li className="flex items-center">
              <span className="text-gray-500">Car Loan EMI Calculator</span>
            </li> */}
        </ol>
      </nav>
      {/* Your existing content */}
      <div className="w-full flex flex-col items-center">
        <div className="w-full flex justify-center">
          <div className="w-full sm:w-[95%] flex flex-col sm:flex-row justify-center items-center">
            <div className="w-full sm:w-[50%]">
              <div className="w-[90%]">
                <h1 className="text-4xl md:text-5xl font-bold mt-6 md:mt-0 md:pl-0 pl-6">
                  <span className="text-blue-600 ">Explore Bike Insurance</span>{" "}
                  Options Now!
                </h1>
                <a href="">
                  <button className="py-4 px-8  border rounded-full bg-blue-600 text-white shadow-lg hover:shadow-xl text-lg mt-10 font-medium">
                    See Plans
                  </button>
                </a>
              </div>
            </div>
            <div className="w-full sm:w-[50%]">
              <img
                className="w-full max-w-full"
                src="../assets/frontbike.webp"
                alt="car-loan"
              />
            </div>
          </div>
        </div>
      </div>
      {/* <div className='w-full h-full md:h-screen flex justify-center'>
                <div className='w-full h-full md:h-screen flex justify-center'>
            <div className='w-[95%] md:flex justify-center items-center '>
              <div className='w-full md:w-[40%] '>
                <h1 className='text-4xl md:text-5xl font-medium text-blue-600 text-center md:text-left mt-10 md:mt-0 '>Explore Bike Insurance
    Options Now!
    </h1>
                <p className='py-3 md:py-5 text-lg md:text-xl text-gray-600 text-center md:text-left'>Zero maintenance charge, trusted by 40M+ Indians.</p>
                <button className='border rounded-full px-6 md:px-8 py-3 md:py-4 bg-blue-600 text-white '>Get Started</button>
              </div>
              <div className='w-full md:w-[60%]'>
                <img className='w-full h-[300px] md:h-[100%] object-cover' src='https://mypolicyexpress.com/wp-content/uploads/2024/04/own-bike-insurance-vs-third-party-insurance.webp' alt='demat growth' />
              </div>
            </div>
          </div>
                </div> */}

      <div className="shadow-lg rounded-lg p-4 md:p-8 lg:p-12 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <p className="text-lg md:text-base lg:text-lg text-center">
          Don't get lost in the complexities of bike insurance policies.
          TheFinMaster.com is here to help you navigate the road to the right
          coverage. We've partnered with leading insurance providers to offer
          you a wide range of bike insurance options. Compare plans, understand
          coverage details, and get free quotes – all conveniently located
          online. Let us help you find the perfect bike insurance plan to keep
          you financially secure and ensure every ride is an adventure, not a
          worry.
        </p>
      </div>
          <div className="container mx-auto">
      <div className="flex flex-col lg:flex-row">
        {/* Main content area with insurance listings */}
        <div className="w-full lg:w-3/4">
          <div id="insurance_plans" className="lg:pr-6 md:px-4 px-2">
            {loading ? (
              <div className="text-center py-10">Loading insurance options...</div>
            ) : error ? (
              <div className="text-center py-10 text-red-600">{error}</div>
            ) : insuranceData.length === 0 ? (
              <div className="text-center py-10">
                No car insurance options available at the moment.
              </div>
            ) : (
          insuranceData.map((insurance) => (
            <div
              key={insurance.id}
              className="w-full max-w-[900px] py-2 border shadow-lg overflow-hidden hover:shadow-xl rounded-lg flex flex-wrap md:flex-nowrap gap-2 md:gap-5 justify-between mx-auto mt-4"
              >
              <div className="flex flex-wrap md:flex-nowrap w-full justify-center items-center md:justify-normal">
                <Link to={`/bike_insurance/${insurance.page_url}`}>
                  <div className="w-[95%] md:w-[220px] overflow-hidden py-2 md:ml-2">
                    <img
                      className="w-full h-full object-contain"
                      alt={insurance.page_title || "Insurance Provider"}
                      src={insurance.image}
                    />
                  </div>
                </Link>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                <p className="text-gray-500 font-medium text-sm md:text-base">Premium Starting </p>
                <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                  @ ₹{insurance.premium_start}
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                <p className="text-gray-500 font-medium text-sm md:text-base">Claim Settlement </p>
                <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                  {insurance.claim_settlement}%
                </h4>
              </div>

              <div className="w-full md:pl-0 pl-4 mt-2 md:mt-6">
                <p className="text-gray-500 font-medium text-sm md:text-base">Network Garages</p>
                <h4 className="text-xl md:text-2xl py-0.5 font-bold">
                  {insurance.network_garages}+
                </h4>
              </div>

              <div className="flex flex-wrap justify-center md:justify-between items-center my-5 w-full gap-2 px-4">
                <a
                  href={insurance.bank_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bg-green-500 text-white font-semibold py-2 px-4 rounded hover:bg-green-600 transition duration-300">
                    Get Quote!
                  </button>
                </a>

                <Link to={`/bike_insurance/${insurance.page_url}`}>
                  <button className="text-white font-semibold py-2 px-4 rounded hover:bg-blue-600 transition duration-300 bg-blue-500">
                    See Details
                  </button>
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
</div>
<div className="w-full lg:w-1/4 px-2 md:px-4 mt-6 lg:mt-0">
          <div className="sticky top-20">
            {/* Ad 1 - Visible on all screen sizes */}
            <a href="https://play.google.com/store/apps/details?id=com.fatakpay&pcampaignid=web_share" target="_blank" rel="noopener noreferrer" className="block">
              <img 
                src="/assets/ftak.jpg" 
                alt="Insurance Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a>
            
            {/* Ad 2 - Hidden on small mobile, visible on larger screens */}
            {/* <a href="https://example.com/premium-discount" target="_blank" rel="noopener noreferrer" className="hidden sm:block mt-6">
              <img 
                src="/assets/niyoo.png" 
                alt="Premium Discount Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
            
            {/* Compact ad for mobile only */}
            {/* <a href="https://example.com/mobile-offer" target="_blank" rel="noopener noreferrer" className="block sm:hidden mt-4">
              <img 
                src="/assets/niyoo.png" 
                alt="Mobile Special Offer" 
                className="w-full rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
              />
            </a> */}
          </div>
        </div>
      </div>
    </div>
      <div className="flex justify-center items-center  p-4 mt-10">
        <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
          <h2 className="text-2xl font-bold text-gray-800 mb-4">
            What is Bike Insurance?
          </h2>
          <p className="text-gray-600 leading-relaxed">
            Bike insurance is a financial safety net that protects two-wheelers,
            including motorcycles, scooters, mopeds, and electric bikes, against
            accidents, theft, fire, riots, and natural calamities. It helps
            cover repair or replacement costs, ensuring that unexpected damages
            don’t result in a significant financial burden.{" "}
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            With the rise of electric mobility, EV protection cover for electric
            two-wheelers is also widely available. Under the Motor Vehicles Act,
            1988, it is mandatory to have at least a third-party bike insurance
            policy to legally ride on Indian roads. If you’re purchasing a new
            bike, you are required to buy a long-term third-party insurance plan
            for up to 5 years to stay compliant and avoid fines of up to ₹2,000.
          </p>
          <p className="text-gray-600 leading-relaxed mt-3">
            Bike insurance not only provides legal and financial protection but
            also offers peace of mind, allowing you to enjoy a worry-free riding
            experience.{" "}
          </p>
        </div>
      </div>

      <div className="bg-gray-100 px-4 py-10 sm:px-6 lg:px-8 mt-4">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-2xl font-bold text-gray-800">
            Important Statistics About Bike Insurance in India
          </h2>
          <div className="mt-6 grid gap-6 md:grid-cols-3">
            {/* Statistic 1 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <h3 className="text-lg font-semibold text-primary-500">
                Over 60% of Two-Wheelers in India Are Uninsured
              </h3>
              <p className="text-gray-600 mt-2">
                According to IRDAI, more than 60% of two-wheelers on Indian
                roads do not have valid insurance, putting riders and third
                parties at financial risk in case of accidents.
              </p>
            </div>

            {/* Statistic 2 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <h3 className="text-lg font-semibold text-primary-500">
                Two-Wheelers Account for Nearly 40% of Road Accidents
              </h3>
              <p className="text-gray-600 mt-2">
                As per MoRTH, two-wheelers contribute to around 40% of road
                accidents in India, making bike insurance essential for
                financial and legal protection.
              </p>
            </div>

            {/* Statistic 3 */}
            <div className="bg-white shadow-lg rounded-lg p-6 text-center">
              <h3 className="text-lg font-semibold text-primary-500">
                Engine Capacity & Insurance Costs
              </h3>
              <p className="text-gray-600 mt-2">
                The premium for third-party bike insurance depends on the engine
                capacity. Bikes up to 75 cc have premiums around ₹482 annually,
                75-150 cc costs ₹752, 150-350 cc is ₹1,193, and above 350 cc is
                ₹2,323 annually.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8 text-center">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
          Bike Insurance Plans That Fit Your Needs
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2">
          Choosing the right bike insurance ensures financial security while
          riding. Here are the three main types of bike insurance plans:
        </p>

        <div className="mt-6 grid md:grid-cols-3 gap-6 text-left">
          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl"> 🚦</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Third-Party Bike Insurance
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              A legal requirement under the Motor Vehicles Act, this policy
              covers damages caused to another person, vehicle, or property by
              your bike. It helps you stay compliant with the law while
              protecting you from third-party liability expenses.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🛡</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Comprehensive Bike Insurance
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              A complete protection plan that covers both third-party
              liabilities and damages to your own bike. It includes coverage for
              accidents, theft, fire, and natural calamities, ensuring
              all-around safety and peace of mind.
            </p>
          </div>

          <div className="p-6 border rounded-lg shadow-md bg-white">
            <span className="text-3xl">🔒</span>
            <h3 className="text-lg font-semibold text-gray-800 mt-2">
              Own Damage Bike Insurance
            </h3>
            <p className="text-gray-700 text-sm mt-1">
              This standalone policy focuses on safeguarding your bike against
              damages from accidents, theft, fire, and natural disasters. It
              offers financial protection exclusively for your vehicle without
              third-party coverage.
            </p>
          </div>
        </div>
      </div>

      {/* <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="overflow-x-auto">
          <table className="w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-100 text-gray-800">
                <th className="p-3 text-left border border-gray-300"></th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Third-Party
                </th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Comprehensive
                </th>
                <th className="p-3 text-center border border-gray-300 font-semibold">
                  Own Damage
                </th>
              </tr>
            </thead>
            <tbody className="text-gray-700">
              {[
                [
                  "Damages/Losses to own car due to an accident",
                  false,
                  true,
                  true,
                ],
                [
                  "Damages/Losses to own car in case of fire",
                  false,
                  true,
                  true,
                ],
                [
                  "Damages/Losses to own car in case of a natural calamity",
                  false,
                  true,
                  true,
                ],
                ["Damages to Third-Party Vehicle", true, true, false],
                ["Damages to Third-Party Property", true, true, false],
                ["Personal Accident Cover", true, true, false],
                ["Injuries/Death of a Third-Party Person", true, true, false],
                ["Theft of your car", false, true, true],
                ["Customize your IDV", false, true, true],
                ["Extra protection with customized add-ons", false, true, true],
              ].map(
                ([feature, thirdParty, comprehensive, ownDamage], index) => (
                  <tr key={index} className="border border-gray-300">
                    <td className="p-3 border border-gray-300">{feature}</td>
                    <td className="p-3 text-center border border-gray-300">
                      {thirdParty ? "✅" : "❌"}
                    </td>
                    <td className="p-3 text-center border border-gray-300">
                      {comprehensive ? "✅" : "❌"}
                    </td>
                    <td className="p-3 text-center border border-gray-300">
                      {ownDamage ? "✅" : "❌"}
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
      </div> */}
 <div className="max-w-7xl mx-auto px-4 py-8">
      {/* Mobile View (Stacked Cards) */}
      <div className="block md:hidden">
        {data.map(([feature, thirdParty, comprehensive, ownDamage], index) => (
          <div
            key={index}
            className="border mb-4 p-4 rounded-lg bg-white shadow-md"
          >
            <h3 className="font-semibold text-gray-800 mb-2">{feature}</h3>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Third-Party:</span>
              <span>{thirdParty ? "✅" : "❌"}</span>
            </div>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Comprehensive:</span>
              <span>{comprehensive ? "✅" : "❌"}</span>
            </div>
            <div className="flex justify-between border-t py-1">
              <span className="text-gray-600">Own Damage:</span>
              <span>{ownDamage ? "✅" : "❌"}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Desktop View (Table) */}
      <div className="hidden md:block overflow-x-auto">
        <table className="min-w-[700px] w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100 text-gray-800">
              <th className="p-3 text-left border border-gray-300">Features</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Third-Party</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Comprehensive</th>
              <th className="p-3 text-center border border-gray-300 font-semibold">Own Damage</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {data.map(([feature, thirdParty, comprehensive, ownDamage], index) => (
              <tr key={index} className="border border-gray-300">
                <td className="p-3 border border-gray-300">{feature}</td>
                <td className="p-3 text-center border border-gray-300">
                  {thirdParty ? "✅" : "❌"}
                </td>
                <td className="p-3 text-center border border-gray-300">
                  {comprehensive ? "✅" : "❌"}
                </td>
                <td className="p-3 text-center border border-gray-300">
                  {ownDamage ? "✅" : "❌"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
      <div className="bg-gray-200 px-4 py-10">
        <div className="mx-auto max-w-6xl">
          <p className="text-center text-base font-semibold leading-7 text-primary-500">
            Why Do You Need Bike Insurance?
          </p>
          <h2 className="text-center text-gray-700 text-lg max-w-3xl mx-auto">
            Bike insurance is more than just a legal necessity—it’s your
            financial safety net against unexpected mishaps on the road. Here’s
            why having the right policy is essential:{" "}
          </h2>
          <ul className="mt-16 grid grid-cols-1 gap-6 text-center text-gray-700 md:grid-cols-3">
            {featuresNew.map((feature, index) => (
              <li
                key={index}
                className="rounded-xl bg-white px-6 py-8 shadow-sm hover:shadow-lg transition-shadow duration-300"
              >
                {feature.icon}
                <h3 className="my-3 font-medium">{feature.title}</h3>
                <p className="mt-1.5 text-sm leading-6 text-gray-600">
                  {feature.description}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="container mx-auto p-6 mt-10">
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 text-center">
          What’s Covered Under Your Bike Insurance? 🔐
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center">
          Bike insurance acts as your financial shield, protecting you from
          unexpected damages and losses. Whether it’s an accident, theft, or
          natural calamity, the right policy ensures you ride worry-free. Here’s
          what your bike insurance covers:{" "}
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 mt-4">
          {cardsNew.map((card, index) => (
            <div
              key={index}
              className="border rounded-lg shadow-lg p-6 flex flex-col items-center text-center"
            >
              <img
                src={card.image}
                alt={card.title}
                className="w-16 h-16 mb-4"
              />
              <h3 className="text-lg font-semibold mb-2">{card.title}</h3>
              <p className="text-gray-600">{card.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">
            Key Factors to Consider While Buying Bike Insurance Online 🏍️💡
          </h1>
          <p className="text-gray-700 mb-6">
            Choosing the right bike insurance policy ensures financial
            protection and hassle-free rides. Here are essential aspects to
            check before making your purchase:{" "}
          </p>

          {points.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className=" px-2 md:px-6 bg-gray-100">
        <div className=" p-6 min-h-screen">
          <h1 className="text-3xl font-bold text-blue-700 mb-4">
            Key Factors That Affect Bike Insurance Premium 🏍️💰
          </h1>
          <p className="text-gray-700 mb-6">
            The cost of your bike insurance is influenced by several crucial
            factors. Understanding these can help you choose the right policy
            while optimizing your premium costs.{" "}
          </p>

          {points2.map((point, index) => (
            <div
              key={index}
              className="mb-4 p-4 bg-white rounded-lg shadow-md border-l-4 border-blue-500"
            >
              <h2 className="text-xl font-semibold text-blue-600">
                {point.title}
              </h2>
              <p className="text-gray-600">{point.description}</p>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ section */}
      <div className="max-w-4xl mx-auto py-6">
        <h1 className="text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default BikeInsuranceNew;
